import * as types from './types'
import storage from '@/plugins/storage'
export default {
  passthrough: '',
  token: storage.local.getItem(types.SESSION_TOKEN_NAME),
  roles: JSON.parse(storage.local.getItem(types.SESSION_ROLES_NAME)),
  userProfile: JSON.parse(storage.local.getItem(types.SESSION_USER_PROFILE)),
  primaryRole: JSON.parse(storage.local.getItem(types.SESSION_PRIMARY_ROLE)),
  userToken: JSON.parse(storage.local.getItem(types.SESSION_USER_TOKEN)),
  userInfo: null,
  businessUsers: [],
  isLogout: false,
  demoMode: storage.local.getItem(types.DEMO_MODE) === 'true',
  language: storage.local.getItem(types.SESSION_LANGUAGE) || '',
  solution: storage.local.getItem(types.SESSION_SOLUTION) || 1,
  isLogging: false,
  showLog: false,
  log: [{
    id: 0,
    component: 'main',
    method: 'init',
    text: 'starting log'
  }],
  systemLog: [{
    id: 1000,
    component: 'main',
    method: 'init',
    text: 'starting system log'
  }
  ],
  languages: [
    {
      name: '',
      value: ''
    },
    {
      name: 'English',
      value: 'en'
    },
    {
      name: 'Croatian',
      value: 'hr'
    },
    {
      name: 'Czech',
      value: 'cs'
    },
    {
      name: 'Danish',
      value: 'da'
    },
    {
      name: 'Dutch',
      value: 'nl'
    },
    {
      name: 'Finnish',
      value: 'fi'
    },
    {
      name: 'French',
      value: 'fr'
    },
    {
      name: 'German',
      value: 'de'
    },
    {
      name: 'Greek',
      value: 'gr'
    },
    {
      name: 'Italian',
      value: 'it'
    },
    {
      name: 'Lithuanian',
      value: 'lt'
    },
    {
      name: 'Norwegian',
      value: 'no'
    },
    {
      name: 'Polish',
      value: 'pl'
    },
    {
      name: 'Portuguese',
      value: 'pt'
    },
    {
      name: 'Slovak',
      value: 'sk'
    },
    {
      name: 'Slovene',
      value: 'sl'
    },
    {
      name: 'Spanish',
      value: 'es'
    },
    {
      name: 'Swedish',
      value: 'sv'
    }
  ],
  notificationToken: storage.local.getItem(types.SESSION_NOTIFICATION_TOKEN),
  mahleDiagnosticLicenseStatus: storage.local.getItem(types.SESSION_MAHLE_DIAGNOSTIC_LICENSE_STATUS),
  mahleCoinBalance: storage.local.getItem(types.SESSION_MAHLE_COIN_BALANCE),
  mahleApiErrorMsg: storage.local.getItem(types.SESSION_MAHLE_API_ERROR_MSG),
  userIsMahle: storage.local.getItem(types.SESSION_USER_ISMAHLE),
  userIsTechPro: storage.local.getItem(types.SESSION_USER_ISTECHPRO),
  termAndConditionsUIMessage: '',
  isRagOnly: storage.local.getItem(types.SESSION_RAG_ONLY) === 'true',
  showRag: storage.local.getItem(types.SESSION_SHOW_RAG) === 'true',
  fullUserData: JSON.parse(storage.local.getItem(types.SESSION_FULL_USER_DATA)) || null
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js